import React from "react";
import { Delete } from "../../../../../shared/svg/delete";
import EditIcon from "../../../../../shared/svg/editIcon";

interface EditDeleteIconsCellProps {
  value: {
    onEdit?: () => void;
    onDelete?: () => void;
  };
}

export const EditDeleteIconsCell: React.FC<EditDeleteIconsCellProps> = ({
  value,
}) => {
  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    value?.onEdit?.();
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    value?.onDelete?.();
  };

  return (
    <div className="flex w-full items-center justify-end gap-4 pr-2">
      <div onClick={handleEditClick} style={{ cursor: "pointer" }}>
        <EditIcon />
      </div>
      <div onClick={handleDeleteClick} style={{ cursor: "pointer" }}>
        <Delete />
      </div>
    </div>
  );
};

export default EditDeleteIconsCell;
